import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import moment from 'moment';
import { useSelector } from 'react-redux';
import { styled } from '@mui/styles';
import {
  darken,
  lighten,
} from '@mui/material';
import timezones from '../../utils/timezones';

const GroupHeader = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: '-8px',
  padding: '4px 10px',
  color: theme.palette.primary.main,
  backgroundColor:
    theme.palette.mode === 'light'
      ? lighten(theme.palette.primary.light, 0.85)
      : darken(theme.palette.primary.main, 0.8),
}));

const GroupItems = styled('ul')({
  padding: 0,
  fontSize: '12px',
});

const TimeSelectComponent = ({
  label,
  value,
  helperText,
  disabled,
  onChange,
  sx,
}) => {
  const myTimezone = useSelector((state) => state.app.myTimezone);
  const selectedLocation = useSelector((state) => state.location.selectedLocation);

  const timezoneWarning = (selectedLocation && selectedLocation.timezone !== myTimezone);

  let timezoneByGroup = [];
  timezoneByGroup.push({
    group: 'Your Timezone',
    timezone: myTimezone,
  })
  if (selectedLocation && selectedLocation.name && timezoneWarning) {
    timezoneByGroup.push({
      group: `Timezone at ${selectedLocation.name}`,
      timezone: selectedLocation.timezone,
    })
  }
  timezoneByGroup = [...timezoneByGroup, ...timezones.map((t) => ({
    timezone: t,
    group: 'All Timezones',
  }))]

  return (
    <Autocomplete
      sx={sx}
      disablePortal
      id="timezone-select"
      options={timezoneByGroup}
      groupBy={(option) => option.group}
      isOptionEqualToValue={(option, valueCompare) => option.timezone === valueCompare}
      renderGroup={(params) => (
        <li key={params.key}>
          <GroupHeader>{params.group}</GroupHeader>
          <GroupItems>{params.children}</GroupItems>
        </li>
      )}
      getOptionLabel={(option) => `${moment.tz((option && option.timezone) || option || 'Unknown').zoneAbbr()} - ${(option && option.timezone) || option || 'Unknown'}`}
      onChange={(e, v) => onChange(e, v.timezone)}
      value={value}
      disableClearable
      disabled={disabled}
      renderInput={(params) => <TextField {...params} size="small" label={label} helperText={helperText} />}
    />
  )
}

TimeSelectComponent.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  sx: PropTypes.object,
};

TimeSelectComponent.defaultProps = {
  label: 'Time',
  value: new Date(),
  disabled: false,
  helperText: null,
  sx: {
    m: 1,
    minWidth: 120,
  },
};

export default (TimeSelectComponent);
